import { render, staticRenderFns } from "./RepaymentDetailsDrawer.vue?vue&type=template&id=4513a7f7&scoped=true"
import script from "./RepaymentDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./RepaymentDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./RepaymentDetailsDrawer.vue?vue&type=style&index=0&id=4513a7f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513a7f7",
  null
  
)

export default component.exports